import type { ComponentProps } from "react";
import { tv } from "tailwind-variants";

const tableHeaderVariants = tv({
  base: "bg-surface-sunken",
});

export const TableHeader = ({ className, ...props }: ComponentProps<"thead">) => {
  return <thead className={tableHeaderVariants({ className })} {...props} />;
};
